import programPage from './program-page/index';
import simpleProgramPage from './program-page/simple.index';

import reactRenderer from './react-renderer';

reactRenderer.add(programPage);
reactRenderer.add(simpleProgramPage);
